<template>
  <el-dialog
    :visible="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :title="title"
    :before-close="onClose"
    width="400"
    center
  >
    <rest-form
      ref="form"
      :save-endpoint="saveEndpoint"
      :after-save="afterSave"
      :model="model"
      :rules="rules"
    >
      <rest-form-item :label="$t('List_Field_Name')" prop="name">
        <el-input v-model="model.name" :placeholder="$t('List_Field_Name')" />
      </rest-form-item>

      <rest-form-item :label="$t('List_Field_Identifier')" prop="identifier">
        <enum-select
          v-model="model.identifier"
          :placeholder="$t('List_Field_Identifier')"
          :options="identifierList"
        />
      </rest-form-item>
    </rest-form>

    <span slot="footer">
      <el-button @click="save" type="primary" icon="ico icon-floppy">
        {{ $t('Lists_UserListCreateDialog_Save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { listIdentifierLabel } from '@/modules/lists/enum/ListRecordEnums'
import { validateIdentifier } from '@/modules/lists/utils'
import { integrationsTypes } from '@/modules/integrations/enum/IntegrationsEnum'
import _ from 'lodash'
import RestForm from '@/common/components/rest/RestForm'

export default {
  components: {
    RestForm,
    EnumSelect,
    RestFormItem
  },

  props: {
    suppress: {
      type: Number,
      required: true
    },
    onClose: {
      type: Function
    },
    externalType: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      model: this.defaultModel(),
      listIdentifierLabel,
      integrationsTypes
    }
  },

  computed: {
    title() {
      if (this.suppress) {
        return this.$t('Lists_SuppressionListCreateDialog_Title')
      } else {
        return this.$t('Lists_UserListCreateDialog_Title')
      }
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `lists`
      })
    },

    rules() {
      return {
        name: {
          required: true
        },
        identifier: {
          required: true
        }
      }
    },

    features() {
      return this.$store.state.app.features || {}
    },

    identifierList() {
      let filtered = Object.keys(this.listIdentifierLabel).filter(key =>
        validateIdentifier(key, this.features)
      )
      if (!this.$store.state.app.features.customerIdEnabled) {
        filtered = filtered.filter(item => item !== 'customer_id')
      }
      return _.pick(this.listIdentifierLabel, filtered)
    },

    isOptimoveList() {
      return this.externalType === integrationsTypes.optimove
    }
  },

  methods: {
    defaultModel() {
      return {
        suppress: this.suppress,
        external_type: this.externalType
      }
    },

    save() {
      this.$refs['form'].save()
    },

    afterSave(model) {
      if (this.suppress) {
        this.$router.push(
          projectRoute({
            name: 'AudienceSuppressionListItems',
            query: { list_id: model.id }
          })
        )
      } else if (this.isOptimoveList) {
        this.$router.push(
          projectRoute({
            name: 'AudienceOptimoveListItems',
            query: { list_id: model.id }
          })
        )
      } else {
        this.$router.push(
          projectRoute({
            name: 'AudienceUserListItems',
            query: { list_id: model.id }
          })
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/ListCreateDialog.vue